window.slate = window.slate || {}
window.theme = window.theme || {}

const swiperus = new Swiper('.upsell-carousel.us', {
  // Optional parameters
  //loop: true,
  slidesPerView: 'auto',
  spaceBetween: 8,
  initialSlide: 0,

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
})

const swiperpwp = new Swiper('.upsell-carousel.pwp', {
  // Optional parameters
  loop: true,
  slidesPerView: 2,
  spaceBetween: 20,
  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
})

/*================ Global ================*/
/**
 * Utility functions to toggle a "no-scroll" state where body can't be scrolled.
 * Useful to when opening modals/minicarts, or to "contain" scrolling inside
 * them on iOS.
 *
 * @exports window.rfd.noscroll.contain()
 * @exports window.rfd.noscroll.apply()
 * @exports window.rfd.noscroll.remove()
 */
;(function noScrollFunction() {
  'use strict'

  var selectors = {
    main: 'body',
    contain: '[data-scroll-contain]',
  }

  var NO_SCROLL_CLASS = 'no-scroll'
  var scrollPosition = 0

  var stickySelector = '.sticky-container'
  var stickyFixedClass = 'is-fixed'
  var stickyMq = 'only screen and (min-width: 990px)'

  /**
   * Switches elements with position: stick to fixed position while
   * body.no-scroll is active. Fixes issue in Firefox where sticky position
   * is document relative (not viewport relative) with body "position: fixed"
   */
  function toggleStickyPositions(toggle) {
    var $stickies = $(stickySelector)

    // ignore when has inline position (Stickyfill active, no fix needed)
    if (!$stickies.length || $stickies.get(0).style.position !== '') {
      return
    }

    if (!toggle) {
      $stickies.each(function noScrollResetStickies() {
        $(this).removeClass(stickyFixedClass).css({
          position: '',
          left: '',
          top: '',
        })
      })

      return
    }

    if (!window.matchMedia(stickyMq).matches) {
      return
    }

    $stickies.each(function noScrollAddStickies() {
      var offset = $(this).offset()
      var offsetTopViewport = offset.top - $(document).scrollTop()
      var offsetLeftViewport = offset.left - $(document).scrollLeft()
      var width = $(this).outerWidth(true)

      $(this).addClass(stickyFixedClass).css({
        left: offsetLeftViewport,
        top: offsetTopViewport,
        width: width,
      })
    })
  }

  /**
   * Disables scrolling on the body element
   */
  function apply() {
    toggleStickyPositions(true)

    scrollPosition = window.pageYOffset
    $('body').addClass(NO_SCROLL_CLASS)
    $(selectors.main).css({
      top: -scrollPosition + 'px',
      position: 'relative',
    })
  }

  /**
   * Restores scrolling on the body element
   */
  function remove() {
    toggleStickyPositions(false)

    $('body').removeClass(NO_SCROLL_CLASS)
    $(selectors.main).css({
      top: '',
      position: '',
    })
    window.scrollTo(0, scrollPosition)
  }

  /**
   * Contains scrolling within the given element. This is useful on iOS
   * to prevent the body scrolling behind an element with its own
   * overflow scrolling.
   *
   * @param {node} overlayEl - DOM node to contain scrolling within
   */
  function contain(overlayEl) {
    var yPosition = null // remember Y position on touch start

    overlayEl.addEventListener(
      'touchstart',
      function noScrollDetectTouch(event) {
        if (event.targetTouches.length === 1) {
          // detect single touch
          yPosition = event.targetTouches[0].clientY
        }
      },
      false,
    )

    /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
     */
    function isOverlayTotallyScrolled() {
      return (
        overlayEl.scrollHeight - overlayEl.scrollTop <= overlayEl.clientHeight
      )
    }

    function disableRubberBand(event) {
      var clientY = event.targetTouches[0].clientY - yPosition

      if (overlayEl.scrollTop === 0 && clientY > 0) {
        // element is at the top of its scroll
        event.preventDefault()
      }

      if (isOverlayTotallyScrolled() && clientY < 0) {
        // element is at the top of its scroll
        event.preventDefault()
      }
    }

    overlayEl.addEventListener(
      'touchmove',
      function noScrollDisableRubberBand(event) {
        if (event.targetTouches.length === 1) {
          // detect single touch
          disableRubberBand(event)
        }
      },
      false,
    )
  }

  function containScrollers() {
    $(selectors.contain).each(function containScrollersLoop() {
      contain(this)
    })
  }

  function init() {
    containScrollers()
  }

  init()

  window.rfd = window.rfd || {}
  window.rfd.noscroll = {}
  window.rfd.noscroll.apply = apply
  window.rfd.noscroll.remove = remove
  window.rfd.noscroll.contain = contain
})()

/**
 * Open and close "off-canvas" / "slide out" / "hamburger" menus.
 *
 * Menus can be opened from links using href="#menu-id", or dynamically from JS.
 *
 * @exports window.rfd.toggleMenu()
 * @exports window.rfd.openMenu()
 * @exports window.rfd.closeMenu()
 * @exports window.rfd.closeAllMenus()
 *
 * @requires window.rfd.noscroll
 */
;(function offCanvasFunction() {
  'use strict'

  var $menus = $('.off-canvas')

  var DIMMER_TRANS_LENGTH = 700

  if (!$menus.length) {
    return
  }

  function dimmerHide() {
    $('.off-canvas__dimmer').addClass('hide')
  }

  function dimmerShow() {
    $('.off-canvas__dimmer').removeClass('hide')
  }

  function afterClose() {
    dimmerHide()
  }

  function closeMenu(menu) {
    var $fullscreenCarousels

    if (window.rfd && window.rfd.noscroll) {
      window.rfd.noscroll.remove()
    }

    $(menu).attr('aria-hidden', true)
    $('body').removeClass(
      'is-offcanvas-open is-offcanvas-push-left is-offcanvas-push-right',
    )

    setTimeout(afterClose, DIMMER_TRANS_LENGTH)
  }

  function closeAllMenus() {
    $menus
      .filter('[aria-hidden="false"]')
      .each(function closeMenusLoop(i, menu) {
        closeMenu(menu)
      })
  }

  function afterOpen() {}

  function openMenu(menu) {
    var $fullscreenCarousels
    var isOpenClass
    var $sliders
    var $focusEl
    if ($(menu).attr('aria-hidden') === 'false') {
      // early return if menu is already open
      return
    }

    if (window.rfd && window.rfd.noscroll) {
      window.rfd.noscroll.apply()
    }

    const swiperus = new Swiper('.upsell-carousel.us', {
      // Optional parameters
      //loop: true,
      slidesPerView: 'auto',
      spaceBetween: 8,
      initialSlide: 0,

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    })

    const swiperpwp = new Swiper('.upsell-carousel.pwp', {
      // Optional parameters
      loop: true,
      slidesPerView: 2,
      spaceBetween: 20,
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    })

    const swipergw = new Swiper('.upsell-carousel.gw', {
      // Optional parameters
      slidesPerView: 2,
      spaceBetween: 20,
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    })

    const swipersamples = new Swiper('.sample-carousel', {
      // Optional parameters
      slidesPerView: 'auto',
      spaceBetween: 8,
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    })

    dimmerShow()

    isOpenClass = 'is-offcanvas-open'
    if ($(menu).is('.off-canvas--push')) {
      isOpenClass += ' is-offcanvas-push'
      if ($(menu).is('.off-canvas--right')) {
        isOpenClass += ' is-offcanvas-push-right'
      }
      if ($(menu).is('.off-canvas--small')) {
        isOpenClass += ' is-offcanvas-small'
      }
    }

    setTimeout(function openMenuTimeout() {
      $(menu).attr('aria-hidden', false)
      $('body').addClass(isOpenClass)
      setTimeout(afterOpen, DIMMER_TRANS_LENGTH)
    }, 0)

    $focusEl = $(menu).find('.js-first-focus').first()

    if (!$focusEl.length) {
      $focusEl = $(menu).find('input, select, textarea').first()
    }
    if (!$focusEl.length) {
      $focusEl = $(menu).find('a.is-active').first()
    }
    if (!$focusEl.length) {
      $focusEl = $(menu).find('a').first()
    }

    //replace ask to buy button when opening mini cart
    if (menu !== '#minicart' && menu.getAttribute('id') == 'minicart') {
      replaceAskToBuy()
    }
  }

  function toggleMenu(menu) {
    var isClosed = $(menu).attr('aria-hidden') === 'true'

    if (isClosed) {
      closeAllMenus()
      openMenu(menu)
    } else {
      closeMenu(menu)
    }
  }

  function addDimmer() {
    var $dimmer = $('<div class="off-canvas__dimmer" />')
    $('body').append($dimmer)
    $dimmer.on('click', function dimmerClick() {
      closeAllMenus()
    })
  }

  function initControls() {
    $menus.each(function initControlsLoop(index, menu) {
      var thisId = $(menu).attr('id')
      var $menuToggles = $('a[href="#' + thisId + '"]')

      $menuToggles.on('click', function menuTogglesClick(e) {
        e.preventDefault()
        toggleMenu(menu)
      })

      $(menu).on(
        'click',
        '.js-offcanvas-close',
        function offCanvasCloseClick(e) {
          e.preventDefault()
          closeMenu(menu)
        },
      )
    })
  }

  function init() {
    addDimmer()
    initControls()
  }

  init()

  window.rfd = window.rfd || {}
  window.rfd.closeAllMenus = closeAllMenus
  window.rfd.closeMenu = closeMenu
  window.rfd.openMenu = openMenu
  window.rfd.toggleMenu = toggleMenu
})()

/**
 * Module for showing alerts and modal/lightbox overlays.
 *
 * Alerts can be shown dynamically from anywhere in JS via:
 * window.rfd.alert(title, desc)
 *
 * Modals can be added by adding modal markup to the page, assigning .modal
 * a unique ID, then trigger by any link with an id="#modal-id"
 *
 * @exports window.rfd.modal.closeAll()
 * @exports window.rfd.modal.close()
 * @exports window.rfd.modal.open()
 * @exports window.rfd.modal.toggle()
 *
 * @requires snippets/modal-alert.liquid
 */
;(function modalAlertFunction() {
  'use strict'

  var TRANS_LENGTH = 400

  var selectors = {
    modal: '[data-modal]',
    modalInner: '.modal__inner',
    closeBtn: '.js-modal-close',
    bodyClassOpen: 'is-modal-open',
  }

  var $modals

  function close(modal) {
    if (window.rfd && window.rfd.noscroll) {
      window.rfd.noscroll.remove()
    }

    $('body').removeClass(selectors.bodyClassOpen)
    $(modal).attr('aria-hidden', true)

    setTimeout(function modalHideTimeout() {
      $(modal).addClass('hide')
    }, TRANS_LENGTH)

    // NOTE: DO NOT USE SLATE'S TRAPFOCUS UTILITY HERE, CAN THROW A MAXRANGE
    // ERROR WHICH CAN CRASH THE BROWSER (POTENTIALLY DURING CART CHANGES IF
    // "MAX QUANT" ERROR IS SHOWN)
  }

  function closeAll() {
    $modals.filter('[aria-hidden="false"]').each(function modalClose(i, menu) {
      close(menu)
    })
  }

  function open(modal) {
    var $focusEl = $(modal).find('.js-first-focus').first()

    if ($(modal).attr('aria-hidden') === 'false') {
      // early return if modal is already open
      return
    }

    if (window.rfd && window.rfd.noscroll) {
      window.rfd.noscroll.apply()
    }

    $(modal).removeClass('hide')
    $(modal).attr('aria-hidden', false)

    setTimeout(function modalAddBodyClass() {
      $('body').addClass(selectors.bodyClassOpen)
    }, 0)

    if (!$focusEl.length) {
      $focusEl = $(modal).find('input, select, textarea, button').first()
    }
    if (!$focusEl.length) {
      $focusEl = $(modal).find('a.is-active').first()
    }
    if (!$focusEl.length) {
      $focusEl = $(modal).find('a').first()
    }

    // NOTE: DO NOT USE SLATE'S TRAPFOCUS UTILITY HERE, CAN THROW A MAXRANGE
    // ERROR WHICH CAN CRASH THE BROWSER (POTENTIALLY DURING CART CHANGES IF
    // "MAX QUANT" ERROR IS SHOWN)
  }

  function toggle(modal) {
    var isClosed = $(modal).attr('aria-hidden') === 'true'

    if (isClosed) {
      closeAll()
      open(modal)
    } else {
      close(modal)
    }
  }

  function initControls() {
    $modals.each(function modalsLoop(index, modal) {
      var thisId = $(modal).attr('id')
      var $modalToggles = $('a[href="#' + thisId + '"]')
      var $modalCloseBtns = $(modal).find(selectors.closeBtn)
      var $modalInner = $(modal).find(selectors.modalInner)

      $(modal).on('click', function modalClickClose() {
        // closes modal on clicking dimmer/overlay
        close(modal)
      })

      $modalInner.on('click', function modalDontClose(e) {
        // stop propagation so clicks in body don't close modal
        e.stopPropagation()
      })

      $modalToggles.on('click', function modalToggle(e) {
        e.preventDefault()
        toggle(modal)
      })

      $modalCloseBtns.on('click', function modalClickClose(e) {
        e.preventDefault()
        close(modal)
      })
    })
  }

  function showAlert(title, desc) {
    var $globalErr = $('#global-error')

    if (!$globalErr.length) {
      console.error('No alert HTML in DOM to display error:')
    }

    if (title) {
      if (title == 'Cart Error') {
        title = 'Oops!'
      }
      $globalErr.find('.modal__title').html('<h3>' + title + '</h3>')
    }
    if (desc) {
      $globalErr.find('.modal__body').html('<p>' + desc + '</p>')
    }

    open($globalErr)
    console.info('Alert:', title, desc)
  }

  function _init() {
    $modals = $(selectors.modal)

    if (!$modals.length) {
      return
    }

    initControls()

    $modals.each(function modalNoScroll() {
      if (window.rfd && window.rfd.noscroll) {
        window.rfd.noscroll.contain(this)
      }
    })
  }

  _init()

  window.rfd.modal = {}
  window.rfd.modal.closeAll = closeAll
  window.rfd.modal.close = close
  window.rfd.modal.open = open
  window.rfd.modal.toggle = toggle
  window.rfd.alert = showAlert
})()

/**
 * AJAX utility functions to enable/disable controls during requests,
 * and catch global errors.
 *
 * @exports window.rfd.enableBtns()
 * @exports window.rfd.disableBtns()
 */
;(function ajaxUtilsFunction() {
  'use strict'

  var selectors = {
    control: '[data-ajax-ctrl]',
    controlTxt: '[data-ctrl-text]',
    activeControl: '[data-ajax-ctrl-active]',
    alwaysTxtChange: '[data-show-ajax-status]',
    cartCount: '[data-cart-item-count]',
    doNotEnable: '[data-is-disabled-by-cart-state]',
  }

  var $controls = null

  window.rfd = window.rfd || {}
  window.rfd.ajaxControlsDisabled = false

  function handleRequestComplete(event, cart) {
    // update cart counts, manually counting so all items belonging to the same
    // bundle are counted as 1
    let cart_item_count = 0
    let bundle_ids_counted = []

    if (!cart || !cart.items) {
      return
    }

    cart.items.forEach(function (item) {
      const bundleID = item.properties._bundleID
      if (bundleID) {
        if (!bundle_ids_counted.includes(bundleID)) {
          bundle_ids_counted.push(bundleID)
          cart_item_count++
        }
      } else {
        cart_item_count += item.quantity
      }
    })
    $(selectors.cartCount).attr('data-cart-item-count', cart_item_count)
    $(selectors.cartCount).html(cart_item_count)

    log(cart_item_count)
  }

  function disable(activeBtn, loadStr, $customBtns) {
    var loadString = loadStr || 'Adding…'
    var $sliders

    // early return if controls already disabled. prevents duplicate calls which
    // can cause issues re-enablind
    if (window.rfd.ajaxControlsDisabled === true) {
      return
    }

    if (activeBtn) {
      $(activeBtn).attr('data-ajax-ctrl-active', true)
    }

    if (!$customBtns || !$customBtns.length) {
      $controls = $(selectors.control).filter(':not([disabled])')
    } else {
      $controls = $customBtns
    }

    $controls.attr('disabled', 'disabled')

    // custom disable for ionRangeSliders
    $sliders = $controls.filter('.range-slider')
    $sliders.siblings('.irs').attr('disabled', 'disabled')

    $controls.each(function controlsLoopOne(i, el) {
      var $txt = $(el).find(selectors.controlTxt)

      if (
        !$(el).is(selectors.alwaysTxtChange) &&
        !$(el).is(selectors.activeControl)
      ) {
        return
      }

      if ($txt.length) {
        $txt.data('orig-text', $txt.text())
        $txt.text(loadString)
      }
    })

    window.rfd.ajaxControlsDisabled = true
  }

  function enable() {
    var $sliders

    if (window.rfd.ajaxControlsDisabled === false) {
      return
    }

    // remove some controls that should not be enabled this includes controls
    // which have been disabled based on cart state between AJAX disable /
    // enable and should stay disabled, e.g. bundle ATCc that are disabled once
    // one bundle is in cart
    $controls = $controls.not(selectors.doNotEnable)

    $controls.each(function controlsLoopTwo(i, el) {
      var $txt = $(el).find(selectors.controlTxt)

      if (
        !$(el).is(selectors.alwaysTxtChange) &&
        !$(el).is(selectors.activeControl)
      ) {
        return
      }

      if ($txt.length) {
        $txt.text($txt.data('orig-text'))
      }
    })
    $controls.removeAttr('data-ajax-ctrl-active').removeAttr('disabled')

    // custom enable for ionRangeSliders
    $sliders = $controls.filter('.range-slider')
    $sliders.siblings('.irs').removeAttr('disabled')

    window.rfd.ajaxControlsDisabled = false

    const swiperus = new Swiper('.upsell-carousel.us', {
      // Optional parameters
      //loop: true,
      slidesPerView: 'auto',
      spaceBetween: 8,
      initialSlide: 0,

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    })

    const swiperpwp = new Swiper('.upsell-carousel.pwp', {
      // Optional parameters
      loop: true,
      slidesPerView: 2,
      spaceBetween: 20,
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    })

    const swipergw = new Swiper('.upsell-carousel.gw', {
      // Optional parameters
      slidesPerView: 2,
      spaceBetween: 20,
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    })

    const swipersamples = new Swiper('.sample-carousel', {
      // Optional parameters
      slidesPerView: 'auto',
      spaceBetween: 8,
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    })
  }

  function handleAjaxError(event, jqXHR, ajaxSettings, thrownError) {
    console.error('AJAX error')
    // console.error(event);
    // console.error('jqXHR', jqXHR);
    // console.error('ajaxSettings', ajaxSettings);
    // console.error('thrownError', thrownError);

    // reload the page, but with query string param. preventing refresh loop
    // if (window.location.href.search('reloaded=true') === -1) {
    //   console.error('Reloading page');
    //   var queryOp = (window.location.href.search(/\?/) === -1) ? '?' : '&';
    //   window.location.href = window.location.href + queryOp + 'reloaded=true';
    // }
  }

  function init() {
    $(document).on('cart.requestComplete', handleRequestComplete)
    $(document).ajaxError(handleAjaxError)
  }

  init()

  // export global utility functions
  window.rfd = window.rfd || {}
  window.rfd.disableBtns = disable
  window.rfd.enableBtns = enable
})()

/**
 * Checks the cart state and updates DOM with any necessary flags. For example,
 * adding body classes flagging there are bundled or subscription products in
 * cart.
 *
 */
;(function mod() {
  function cartStateCheck() {
    if (!Shopify || !Shopify.cart) {
      return
    }

    if (window.rfd && window.rfd.addBundleDiscount) {
      window.rfd.addBundleDiscount()
    }

    if (window.rfd && window.rfd.setBundleATCState) {
      window.rfd.setBundleATCState()
    }
  }

  function cartStateUpdate() {
    Shopify.cart = Shopify.cart || []

    $.getJSON('/cart.js', function (cart) {
      Shopify.cart = cart
      cartStateCheck()
    })
  }

  window.rfd.cartStateUpdate = cartStateUpdate
  window.rfd.cartStateCheck = cartStateCheck
})()

/**
 * Handles adding to cart via AJAX (product forms + "Quick Add" buttons)
 *
 * @requires vendor/_cart.min.js
 */
;(function cartAddFunction() {
  'use strict'

  var selectors = {
    singleOptionSelector: '[data-single-option-selector]',
    productForms: '[data-ajax-product-form]',
    quickAddBtns: '[data-quick-add-to-cart]',
    quickAddVariantIdAttr: 'data-quick-add-to-cart',
    quickAddHolder: '[data-quick-add-holder]',
    quickAddPropsAttr: 'data-custom-properties',
  }

  /**
   * Takes product variant data and adds it/them to Shopify's cart via AJAX.
   * Multiple variants are added in sequence, in order they appear in array.
   *
   * @private
   * @param {Object|Object[]} data - CartJS data, or an array of CartJS data
   * @param {Number} data.variantId - Variant ID of product
   * @param {Number} data.quantity - Quantity of product
   * @param {Object} [data.customProperties] - Custom properties for cart line item
   * @param {Function} [callback] - Custom callback following completion
   */
  function ajaxAddToCart(data, callback) {
    Shopify.queue = []

    // Vet data & add to queue
    if (data.variantId && data.quantity) {
      Shopify.queue.push(data)
    } else if (data.length) {
      data.forEach(function vetDataLoop(d) {
        if (d.variantId && d.quantity) {
          Shopify.queue.push(d)
        } else {
          console.error('[cart-add] invalid data', d)
        }
      })
    } else {
      console.error('[cart-add] invalid data', data)
      return
    }

    // Process the queue
    Shopify.moveAlong = function processQueue() {
      var request
      if (Shopify.queue.length) {
        request = Shopify.queue.shift()
        request.customProperties = request.customProperties || {}

        // Make AJAX submission
        CartJS.addItem(
          request.variantId,
          request.quantity,
          request.customProperties,
          {
            success: function cartAddAjaxSuccess(data) {
              Shopify.moveAlong()
              setTimeout(replaceAskToBuy, 500)
            },
          },
        )
      } else {
        console.timeEnd('[cart-add]')

        if (window.rfd && window.rfd.cartStateUpdate) {
          window.rfd.cartStateUpdate()
        }

        if (callback) {
          callback()
        } else {
          window.rfd.renderCart(false, window.rfd.enableBtns)
        }
      }
    }
    console.time('[cart-add]')
    Shopify.moveAlong()
  }

  function onRemoveError(jqXHR, textStatus, errorThrown) {
    console.timeEnd('[cart-add]')
    console.error(jqXHR, textStatus, errorThrown)

    if (window.rfd && window.rfd.enableBtns) {
      window.rfd.enableBtns()
    }

    if (
      window.rfd &&
      window.rfd.alert &&
      jqXHR.responseJSON &&
      jqXHR.responseJSON.message &&
      jqXHR.responseJSON.description
    ) {
      window.rfd.alert(
        jqXHR.responseJSON.message,
        jqXHR.responseJSON.description,
      )
      $.magnificPopup.instance.close() // Close popup that is currently opened
      window.rfd.renderCart(true, window.rfd.enableBtns) // Render minicart
    }
  }

  /**
   * Gets variant data for CartJS from a Shopify product form
   *
   * @private
   * @param {jQuery} form - <form> element output by {% form 'product' %}
   * @returns {object|null} data for CartJS submission if found, or null
   */
  function getFormData(form) {
    var id = $(form).find('[name="id"]').first().val()

    var quant = $(form).find('[name="quantity"]').first().val()

    var upsell = $(form).find('[name="pdp-upsell-checkbox"]').first()
    var upsell_id = false
    var upsell_price = false
    var upsell_compare_price = false
    var upsell_discount = false
    var upsell_props = {}

    if (upsell.prop('checked') == true) {
      upsell_id = parseInt(upsell.val())
      if (
        window.theme &&
        window.theme.line_item_properties_enabled === 'true'
      ) {
        upsell_price = upsell.attr('data-price')
        upsell_compare_price = upsell.attr('data-compare-price')
        upsell_discount = upsell.attr('data-discount')
        upsell_props['Price'] = upsell_price
        upsell_props['Compare_Price'] = upsell_compare_price
        upsell_props['Discount'] = upsell_discount
      }
    }

    // Find custom property fields and add to object for CartJS use
    var customProperties = {}
    var $customPropFields = $(form).find('[name^="properties"]')

    id = parseInt(id, 10)

    if (!id) {
      console.error('[cart-add] no variant id', id)
      return null
    }

    if (!quant) {
      quant = 1
      console.info('[cart-add] no quant found in DOM, defaulting to 1')
    }

    $customPropFields.each(function cartAddPropLoop() {
      var propVal = $(this).val()
      var propName = $(this)
        .attr('name')
        .replace(/properties\[/gi, '')
        .replace(/\]/gi, '')

      customProperties[propName] = propVal
    })

    return {
      variantId: id,
      upsellId: upsell_id,
      upsellProps: upsell_props,
      quantity: quant,
      customProperties: customProperties,
    }
  }

  /**
   * Adds a product to cart via AJAX when product form submitted.
   *
   */
  function handleProductFormSubmit(e) {
    var formData = getFormData(this)
    var $submitBtn = $(this).find('[type="submit"]')
    var addData = []

    if (formData.upsellId != false) {
      addData.push(formData)
      addData.push({
        variantId: formData.upsellId,
        quantity: formData.quantity,
        customProperties: formData.upsellProps,
      })
    } else {
      addData = formData
    }

    e.preventDefault()

    // check maximum in basket not already reached
    $.getJSON('/cart.js', function (cart) {
      var variantToAdd = addData.variantId
      var currentCartItems = cart.items

      for (var i = 0; i < currentCartItems.length; i++) {
        if (
          cart.items[i].variant_id === variantToAdd &&
          cart.items[i].quantity >= 5
        ) {
          window.rfd.openMenu('#minicart')
          return
        }
      }

      if (window.rfd && window.rfd.disableBtns) {
        window.rfd.disableBtns($submitBtn)
      }
      if (addData) {
        ajaxAddToCart(addData)
      }
    })
  }

  function getRandomStr(length) {
    var c
    for (c = ''; c.length < length; ) {
      c += Math.random().toString(36).substr(2, 1)
    }
    return c
  }

  /**
   * Adds product(s) to cart via AJAX when "Quick Add" button clicked.
   */

  function handleQuickAddBtnClick(e) {
    var variantIds = $(this).attr(selectors.quickAddVariantIdAttr)
    var variantIdsArr = variantIds.split(',')
    var variantsData = []
    var lineItemProps = $(this).attr(selectors.quickAddPropsAttr)
    var quantEl = $(this)
      .closest(selectors.quickAddHolder)
      .find('[name="quantity"]')
    var quant = 1

    if (quantEl.length) {
      quant = quantEl.first().val()
    }

    if (lineItemProps) {
      lineItemProps = lineItemProps.replace(/\[guid\]/gi, getRandomStr(32))
      try {
        lineItemProps = JSON.parse(lineItemProps)
      } catch (err) {
        console.error(
          '[card-add] invalid JSON supplied for line item properties',
          err,
        )
      }
    }

    e.preventDefault()

    if (!variantIds) {
      console.error('[cart-add] no variant IDs on add button')
      return
    }

    if (window.theme && window.theme.line_item_properties_enabled === 'true') {
      variantIdsArr.forEach(function cartAddVariantLoop(id, ind) {
        let props

        if (lineItemProps.length > 1) {
          if (lineItemProps[ind]) {
            props = lineItemProps[ind]
          } else {
            props = {}
          }
        } else if (lineItemProps) {
          props = lineItemProps
        } else {
          props = {}
        }

        variantsData.push({
          quantity: quant,
          variantId: parseInt(id, 10),
          customProperties: props,
        })
      })
    } else {
      variantIdsArr.forEach(function cartAddVariantLoop(id) {
        variantsData.push({
          quantity: quant,
          variantId: parseInt(id, 10),
          customProperties: lineItemProps ? lineItemProps : {},
        })
      })
    }

    // // check maximum in basket not already reached
    $.getJSON('/cart.js', function (cart) {
      var variantToAdd = variantsData[0].variantId
      var currentCartItems = cart.items

      for (var i = 0; i < currentCartItems.length; i++) {
        if (
          cart.items[i].variant_id === variantToAdd &&
          cart.items[i].quantity >= 5
        ) {
          window.rfd.openMenu('#minicart')
          return
        }
      }

      if (window.rfd && window.rfd.disableBtns) {
        window.rfd.disableBtns(this)
      }

      ajaxAddToCart(variantsData)
    })
  }

  function init() {
    $('body').on('submit', selectors.productForms, handleProductFormSubmit)
    $('body').on('click', selectors.quickAddBtns, handleQuickAddBtnClick)
  }

  init()
})()

/**
 * Handles removing from cart via AJAX (minicart "Remove" buttons)
 *
 * @requires vendor/_cart.min.js
 */
;(function cartRemoveFunction() {
  'use strict'

  var selectors = {
    cartForm: '[data-cart]',
    removeBtns: '[data-cart-remove]',
    lineNumberAttr: 'data-cart-remove',
    lineAmount: 'data-item-price',
    cartItem: '[data-cart-item]',
    cartValue: 'data-cart-total-price',
    totalCartItems: 'data-cart-total-items',
    singlePrice: 'data-item-single-price',
    itemTitle: 'data-item-title',
    itemSKU: 'data-item-sku',
    itemType: 'data-item-type',
    itemProdId: 'data-product-id',
    removeSampleAttr: '.cart--remove-sample',
    sampleRemove: '.js-remove-sample-product',
  }

  function onRemoveComplete() {
    console.timeEnd('[cart-remove]')
    window.rfd.renderCart(false, window.rfd.enableBtns)

    // If cart total is 0, remove sample product
    // Wait until cart has rendered
    setTimeout(function () {
      if ($(selectors.removeSampleAttr).length) {
        $(selectors.sampleRemove).click()
      }
    }, 1000)
  }

  function onRemoveError(jqXHR, textStatus, errorThrown) {
    console.error(jqXHR, textStatus, errorThrown)

    if (window.rfd && window.rfd.enableBtns) {
      window.rfd.enableBtns()
    }

    if (
      window.rfd &&
      window.rfd.alert &&
      jqXHR.responseJSON &&
      jqXHR.responseJSON.message &&
      jqXHR.responseJSON.description
    ) {
      window.rfd.alert(
        jqXHR.responseJSON.message,
        jqXHR.responseJSON.description,
      )
    }
  }

  /**
   * Removes a line item from the cart (optionally changing remove button state)
   *
   * @param {array} lineNumbersArr - array of cart line item numbers to be removed
   * @param {jQuery} [removeBtn] - button to change state during operation
   */
  function removeItemsFromCart(lineNumbersArr, removeBtn) {
    console.time('[cart-remove]')

    if (removeBtn) {
      window.rfd.disableBtns(removeBtn, 'Removing…')
    }

    Shopify.cart = []
    Shopify.queue = []

    lineNumbersArr.forEach(function (x) {
      Shopify.queue.push(x)
    })

    // co-erce line numbers into integers
    Shopify.queue = Shopify.queue.map((x) => parseInt(x))

    // sort queue into reverse-numerical order
    // (must remove highest line numbers first)
    Shopify.queue.sort((a, b) => b - a)

    Shopify.moveAlong = function () {
      var request

      if (Shopify.queue.length === 0) {
        onRemoveComplete()
        return
      }

      request = Shopify.queue.shift()

      CartJS.removeItem(request, {
        success: function () {
          var removedItem = Shopify.cart.items.splice(request - 1, 1)

          if (window.rfd && window.rfd.cartStateCheck) {
            window.rfd.cartStateCheck()
          }

          Shopify.moveAlong()
        },
        error: onRemoveError,
      })
    }

    // initial call to cart.js, which gives us a reference of removed data
    $.getJSON('/cart.js', function (cart) {
      Shopify.cart = cart
      Shopify.moveAlong()
    })
  }

  /**
   * Removes item from cart on button click
   */
  function handleRemoveClick(e) {
    var lineNumbers = $(this).attr(selectors.lineNumberAttr)
    var lineNumbersArr = lineNumbers.split(',')
    var removeBtn = this
    var removeAmount = $(this).attr(selectors.lineAmount)
    var totalAmount = $('#cart-subtotal').attr(selectors.cartValue)
    var totalItems = $('#cart-subtotal').attr(selectors.totalCartItems)

    e.preventDefault()

    if (removeAmount) {
      if (removeAmount == totalAmount) {
        var x
        for (x = 1; x <= totalItems; x++) {
          if (x === 1) {
            lineNumbersArr = [x]
          } else {
            lineNumbersArr.push(x)
          }
        }
      }
    }

    if (lineNumbersArr.length && lineNumbersArr[0]) {
      removeItemsFromCart(lineNumbersArr, removeBtn)
    } else {
      console.error('[cart-remove] invalid line numbers', lineNumbersArr)
    }
  }

  function init() {
    $(document).on('click', selectors.removeBtns, handleRemoveClick)
  }

  init()
})()

/**
 * Update cart in DOM via AJAX
 *
 * @exports window.rfd.renderCart()
 *
 * @requires vendor/cart.min.js
 * @requires _off-canvas.js
 */
;(function cartRenderFunction() {
  'use strict'

  var selectors = {
    minicart: '#minicart',
    cartForm: '[data-cart]',
    alwaysStayClosed: 'body.template-cart',
  }

  var cartAjaxTemplate = '/cart?view=ajax'
  var cartPageTemplate = '/cart?view=cart-page'

  /**
   * Updates the DOM and re-fires JavaScript as necessary
   *
   * @param {boolean} dontOpen - whether to open minicart after updating
   * @param {function} callback - callback to fire after updating
   */
  function renderCart(dontOpen, callback) {
    var $cartEls = $(selectors.cartForm)
    var chosenCartTemplate = cartAjaxTemplate
    if ($(selectors.alwaysStayClosed).length) {
      chosenCartTemplate = cartPageTemplate
    }

    if (!$cartEls.length) {
      return
    }

    console.time('[cart-render]')

    $.get(chosenCartTemplate, function cartRenderAjax(data) {
      var doNotOpen = dontOpen
      $(selectors.cartForm).replaceWith($(data).find(selectors.cartForm))

      // re-fire resposive images polyfill for IE11

      const swiperus = new Swiper('.upsell-carousel.us', {
        // Optional parameters
        //loop: true,
        slidesPerView: 2,
        initialSlide: 0,

        spaceBetween: 8,
        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
        },

        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        // And if we need scrollbar
        scrollbar: {
          el: '.swiper-scrollbar',
        },
      })

      // re-initialise variant selectors
      if (window.rfd && window.rfd.initQuickAddVariants) {
        window.rfd.initQuickAddVariants()
      }

      // don't open minicart on cart template
      if ($(selectors.alwaysStayClosed).length) {
        doNotOpen = true
      }

      if (doNotOpen !== true && window.rfd && window.rfd.openMenu) {
        // close any open modals
        if ($.magnificPopup) {
          $.magnificPopup.close()
        }

        // open the mini-cart
        window.rfd.openMenu(selectors.minicart)

        if (window.Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize()
        }

        // Add spinner when updating minicart
        $('.cart__body').addClass('cart__body--updating')
        setTimeout(function () {
          $('.cart__body').removeClass('cart__body--updating')
        }, 200)
      }

      if (window.rfd && window.rfd.addBundleDiscount) {
        window.rfd.addBundleDiscount()
      }

      console.timeEnd('[cart-render]')

      if (callback) {
        callback()
      }

      //function created in cart-update.js to update carticon with fetch request
      updateCartIcon()

      if (typeof reChargeCartJS !== 'undefined') {
        reChargeCartJS()
      }

      var modal = document.getElementById('minicart')
      modal.focus()
      replaceAskToBuy()
    })
  }

  window.rfd.renderCart = renderCart
})()

/**
 * Handles changing cart quantities via AJAX (minicart "Quantity" togglers)
 *
 * @requires vendor/_cart.min.js
 */
;(function cartUpdateFunction() {
  'use strict'

  var selectors = {
    quant: '[data-item-quantity]',
    removeBtn: '[data-cart-remove]',
    cartItem: '[data-cart-item]',
    lineNumberAttr: 'data-item-quantity',
    currentQuantAttr: 'data-current-val',
    singlePrice: 'data-item-single-price',
    itemTitle: 'data-item-title',
    itemSKU: 'data-item-sku',
    itemType: 'data-item-type',
    itemProdId: 'data-product-id',
  }

  /**
   * Updates cart item to new quantity
   *
   * @param {number} lineNumber - cart line number to change
   * @param {number} newQuant - quantity to change to
   * @param {jQuery} [control] - element to show status text during AJAX
   */
  function updateQuant(lineNumber, newQuant, control, quantDelta) {
    console.time('[cart-update]')

    if (control && window.rfd && window.rfd.disableBtns) {
      window.rfd.disableBtns(control, 'Updating…')
    }

    var $currentLineItem = control.closest(selectors.cartItem)
    var currentLineItemVariantID = $currentLineItem.attr('data-variant-id')
    var currentLineItemProductID = $currentLineItem
      .find('input')
      .attr(selectors.itemProdId)
    var currentLineItemTitle = $currentLineItem
      .find('input')
      .attr(selectors.itemTitle)
    var currentLineItemSKU = $currentLineItem
      .find('input')
      .attr(selectors.itemSKU)
    var currentLineItemType = $currentLineItem
      .find('input')
      .attr(selectors.itemType)
    var currentLineItemPrice =
      $currentLineItem.find('input').attr(selectors.singlePrice) / 100

    CartJS.updateItem(
      lineNumber,
      newQuant,
      {},
      {
        success: function cartUpdateAjaxSuccess(cart) {
          //console.timeEnd("[cart-update]");

          if (window.rfd && window.rfd.renderCart) {
            window.rfd.renderCart(false, window.rfd.enableBtns)
          }
        },
        error: function cartUpdateAjaxError(jqXHR, textStatus, errorThrown) {
          console.timeEnd('[cart-update]')
          console.error(jqXHR, textStatus, errorThrown)

          if (window.rfd && window.rfd.enableBtns) {
            window.rfd.enableBtns()
          }

          if (
            window.rfd &&
            window.rfd.alert &&
            jqXHR.responseJSON &&
            jqXHR.responseJSON.message &&
            jqXHR.responseJSON.description
          ) {
            window.rfd.alert(
              jqXHR.responseJSON.message,
              jqXHR.responseJSON.description,
            )
          }
        },
      },
    )
  }

  /**
   * Checks quantity value and if valid, update via AJAX.
   */
  function handleQuantChange(e) {
    // get quantity info
    var $control = $(this)
    var oldQuant = parseInt($control.attr(selectors.currentQuantAttr), 10)
    var newQuant = parseInt($control.val(), 10)
    var maxQuant = $control.attr('max')
    var minQuant = $control.attr('min')
    var lineNumber = $control.attr(selectors.lineNumberAttr)

    // check for co-located "remove button", and pass this as the button to show
    // status during AJAX (quantity fields can't show status text well)
    var $removeBtn = $(this)
      .closest(selectors.cartItem)
      .find(selectors.removeBtn)

    e.preventDefault()

    if (maxQuant && newQuant > maxQuant) {
      newQuant = maxQuant
    }
    if (minQuant && newQuant < minQuant) {
      newQuant = minQuant
    }

    if (newQuant === oldQuant) {
      return
    }

    updateQuant(lineNumber, newQuant, $removeBtn, newQuant - oldQuant)
  }

  function init() {
    $('body').on('change', selectors.quant, handleQuantChange)
  }

  init()
})()

/*================ Modules ================*/
/**
 * Add .touchevents on demand (on first touch event).
 * This method is more reliable than Modernizr/relying on browser
 * reporting support for touch events.
 *
 */

$(function detectTouchEvents() {
  // on-demand touch class detection on top of Modernizr
  $('html').one('touchstart', function onTouchStart() {
    $('body').addClass('touchevents').removeClass('no-touchevents')
  })
})

/**
 * Module for product quantity selectors with custom +/- buttons
 *
 */
;(function productQuantityFunction() {
  var selectors = {
    input: '[data-quant-input]',
    select: '[data-quant-select]',
    minus: '[data-quant-minus]',
    plus: '[data-quant-plus]',
    quickAddInput: '[data-quick-add-holder] [data-quant-input]',
  }

  /**
   * Adjusts quant input by the given amount.
   *
   * @param {object} adjustCtrl - DOM element with '[data-for]' attribute
   * @param {number} amount - positive/negative integer to adjust amount by
   * @returns {undefined} undefined
   */
  function adjustVal(adjustCtrl, amount) {
    var fieldSelector = $(adjustCtrl).attr('data-for')
    var $field = $(adjustCtrl)
      .closest('form')
      .find(selectors.input)
      .filter(fieldSelector)
      .first()
    var minVal = parseInt($field.attr('min'), 10)
    var maxVal = parseInt($field.attr('max'), 10)
    var currentVal = parseInt($field.val(), 10)
    var newVal = currentVal + amount

    // for unavailable products where "maxVal" might be 0
    if (minVal > maxVal) {
      maxVal = minVal
    }

    if ($field.prop('disabled') === true) {
      return
    }

    if (!Number.isNaN(minVal) && newVal < minVal) {
      return
    }

    if (!Number.isNaN(maxVal) && newVal > maxVal) {
      return
    }

    if (currentVal === newVal) {
      return
    }

    if (Number.isNaN(newVal)) {
      return
    }

    $(adjustCtrl)
      .closest('form')
      .find(fieldSelector)
      .val(newVal)
      .trigger('change')
  }

  /**
   * Updates all quantity inputs when one changes, capping at max/min vals
   *
   * @param {object} event - event object
   * @param {booleam} isSelect - adjust behaviour for selects (which can't take arbitrary integers)
   * @returns {undefined} undefined
   */
  function handleValChange(event, isSelect) {
    var maxVal = parseInt($(this).attr('max'), 10)
    var minVal = parseInt($(this).attr('min'), 10)
    var newVal = parseInt($(this).val(), 10)

    if (!isSelect && maxVal && !Number.isNaN(maxVal) && newVal > maxVal) {
      newVal = maxVal
    }

    if (!isSelect && minVal && !Number.isNaN(minVal) && newVal < minVal) {
      newVal = minVal
    }

    $(this).closest('form').find(selectors.input).val(newVal)
  }

  function handleMinusClick(e) {
    e.preventDefault()
    adjustVal(this, -1)
  }

  function handlePlusClick(e) {
    e.preventDefault()
    adjustVal(this, 1)
  }

  /**
   * Prevents clicking on quant picker going to PDP due to parent <a>
   */
  function handleQuickAddClick(e) {
    e.preventDefault()
  }

  function init() {
    $(selectors.quickAddInput).on('click', handleQuickAddClick)
    $(selectors.input).on('change', handleValChange)
    $(selectors.select).on('change', function (e) {
      handleValChange.call(this, e, true)
    })
    $('body').on('click', selectors.minus, handleMinusClick)
    $('body').on('click', selectors.plus, handlePlusClick)
  }

  init()
})()

/*================ Hacks ================*/
/**
 * A place for temporary hacks (hopefully empty)
 *
 */

$(document).ready(function () {
  if (window.rfd && window.rfd.cartStateUpdate) {
    window.rfd.cartStateUpdate()
  }
})

//add click event of ask to buy button to the new "share my cart" button in mini cart
function replaceAskToBuy() {
  const askToBuy = document.querySelector('.atb-container')
  if (askToBuy !== null) {
    // replaces click event of new icon with the original event
    $('#send-cart').click(function () {
      $('.ask-to-buy-btn').click()
    })
  }
}

replaceAskToBuy()
